import Header from "./components/header/header";
import OrderList from "./components/orderList/orderList";
import SocketManager from "./components/SocketManager/SocketManager";
import ConfirmDialog from "../../components/ConfirmDialog/ConfirmDialog";

const OrderSync = () => {
    return (
        <div>
            <ConfirmDialog/>
            <Header/>
            <OrderList/>
            <SocketManager/>
        </div>
    )
}

export default OrderSync